import { LEAD_STATUSES } from '../../Leads/LeadCard/typings'
import { OPPORTUNITY_STATUSES } from '../../Opportunities/OpportunityCard/typings'
import { selectSalesFunnelById } from '@user/store/salesFunnel/slice'
import { ENTITY_TYPES } from '@sales-center/common'
import { useAppSelector } from '@user/store/hooks'
import { useSchedulingEnabled } from '@user/store/scheduling'
import type { RequirementsToCloseProps } from '../typings'
import { useSchedulingVisibility } from '@user/store/closingRequirements'

export function useData(props: RequirementsToCloseProps) {
  const {
    oppStatus,
    leadStatus,
    entityType,
    salesFunnelId,
    scheduleSettings,
    requirementsAndCounts: { agreementsCount, paymentsCount },
  } = props

  const agreementIsComplete = agreementsCount > 0

  const deleteServiceWarningMessage =
    entityType === ENTITY_TYPES.Lead
      ? ''
      : 'Opportunities require at least one product or service'

  const isDisqualifiedLead =
    !!leadStatus && leadStatus == LEAD_STATUSES.Disqualified

  const minimumServicesCount = entityType === ENTITY_TYPES.Lead ? 0 : 1

  const oppIsClosed =
    oppStatus == OPPORTUNITY_STATUSES.Lost ||
    oppStatus == OPPORTUNITY_STATUSES.Won

  const paymentIsComplete = paymentsCount > 0

  const salesFunnel = useAppSelector((state) =>
    selectSalesFunnelById(state, salesFunnelId),
  )

  const schedulingEnabled = useSchedulingEnabled()
  const schedulingVisible = useSchedulingVisibility(scheduleSettings)
  const showScheduling = schedulingEnabled && schedulingVisible

  const recordClosed =
    entityType === ENTITY_TYPES.Lead ? isDisqualifiedLead : oppIsClosed

  return {
    recordClosed,
    showScheduling,
    agreementIsComplete,
    deleteServiceWarningMessage,
    isDisqualifiedLead,
    minimumServicesCount,
    oppIsClosed,
    paymentIsComplete,
    salesFunnel,
  }
}
